import React from "react";
import { useStaticQuery, graphql } from "gatsby";
import { Link, injectIntl } from "gatsby-plugin-intl";
import classnames from "classnames";
import FocusTrap from "focus-trap-react";
import Logo from "../../assets/Logo";
import MenuCloseIcon from "../../assets/MenuCloseIcon";
import cssClass from "./MobileNavigation.module.scss";

import LanguagePicker from "./LanguagePicker";

const MobileNavigation = ({ isOpen, closeFunction, intl }) => {
  const data = useStaticQuery(graphql`
    query {
      allContentfulFindYourClinicPage {
        nodes {
          name
          slug
          node_locale
        }
      }
      allContentfulUnderstandFertilityPage {
        nodes {
          name
          slug
          node_locale
        }
      }
    }
  `);

  const {
    name: clinicsName,
    slug: clinicsSlug,
  } = data.allContentfulFindYourClinicPage.nodes.filter(
    (node) => node.node_locale === intl.locale
  )[0];

  const {
    name: articlesName,
    slug: articlesSlug,
  } = data.allContentfulUnderstandFertilityPage.nodes.filter(
    (node) => node.node_locale === intl.locale
  )[0];

  const navigationSchemaWithHome = [
    {
      title: "Home",
      path: "/",
    },
    {
      title: clinicsName,
      path: `/${clinicsSlug}`,
    },
    {
      title: articlesName,
      path: `/${articlesSlug}`,
    },
  ];

  return (
    <FocusTrap active={isOpen}>
      <div
        className={classnames(cssClass.navigationOuter, {
          [cssClass.hidden]: !isOpen,
        })}
        aria-hidden={!isOpen}
      >
        <div className={cssClass.navigationInner}>
          <div className={cssClass.navigationAndLogoContainer}>
            <div className={cssClass.topRow}>
              <Link aria-label="To homepage" to="/">
                <Logo invert colorIcon />
              </Link>
              <button className={cssClass.closeButton} onClick={closeFunction}>
                <MenuCloseIcon />
              </button>
            </div>

            <nav className={cssClass.navigation}>
              <ul>
                {navigationSchemaWithHome.map((navigationItem) => {
                  return (
                    <li key={navigationItem.title}>
                      <Link to={navigationItem.path}>
                        {navigationItem.title}
                      </Link>
                    </li>
                  );
                })}
              </ul>
            </nav>
          </div>

          <div className={cssClass.languagePickerContainer}>
            <p>Language</p>
            <LanguagePicker isMobileNav={true} />
          </div>
        </div>
      </div>
    </FocusTrap>
  );
};

export default injectIntl(MobileNavigation);
